export default function checkLogin() {
  return (
    localStorage.getItem('tokenInfo') !== '' &&
    localStorage.getItem('tokenInfo') !== null
  );
}
